/**
 * Module Permissions Configuration
 * Based on: Permissions_for_Modules_in_Converge.xlsx
 *
 * Rules:
 * - "NO": Checkbox should be disabled
 * - "NA" or null/undefined: Checkbox should be disabled
 * - "YES": Checkbox should be enabled
 */

export const MODULE_PERMISSIONS_CONFIG = {
  "Api Builder": {
    edit: "NO",
    delete: "NO",
  },
  "Query Builder": {
    edit: "NO",
    delete: "NO",
  },
  Services: {
    edit: "NO",
    delete: "NO",
  },
  "API Published Dashboards": {
    edit: "NO",
    delete: "NO",
  },
  "API Dashboard Builder": {
    edit: "NO",
    delete: "NO",
  },
  "Dashboard Builder": {
    edit: "NO",
    delete: "NO",
  },
  "API Query Builder": {
    edit: "NO",
    delete: "NO",
  },
  "API Services": {
    edit: "NO",
    delete: "NO",
  },
  "Api Services": {
    edit: "NO",
    delete: "NO",
  },
  "Published Dashboards": {
    edit: "NO",
    delete: "NO",
  },
  "Add Bank": {
    edit: "NO",
    delete: "NO",
  },
  "All Banks": {
    edit: "YES",
    delete: "YES",
  },
  "Add Branch": {
    edit: "NO",
    delete: "NO",
  },
  "All Branches": {
    edit: "YES",
    delete: "YES",
  },
  "District wise Branches": {
    edit: "NO",
    delete: "NO",
  },
  "Add ATM": {
    edit: "NO",
    delete: "NO",
  },
  "All ATMs": {
    edit: "YES",
    delete: "YES",
  },
  "District wise ATMs": {
    edit: "NO",
    delete: "NO",
  },
  "GIS Mapping": {
    edit: "NO",
    delete: "NO",
  },
  "Create Incident": {
    edit: "NO",
    delete: "NO",
  },
  "All Incidents": {
    edit: "YES",
    delete: "YES",
  },
  "SOP list": {
    edit: "YES",
    delete: "YES",
  },
  "Create Tasks": {
    edit: "YES",
    delete: "YES",
  },
  "Create SOP": {
    edit: "NO",
    delete: "NO",
  },
  "Execute Sops": {
    edit: "NO",
    delete: "NO",
  },
  "Sop Instance List": {
    edit: "YES",
    delete: "NO",
  },
  "My Task List": {
    edit: "NO",
    delete: "NO",
  },
  "Task Management": {
    edit: "NO",
    delete: "NO",
  },
  "New Announcements": {
    edit: "NA",
    delete: "NA",
  },
  "Document Repository": {
    edit: "NA",
    delete: "NA",
  },
  Circulars: {
    edit: "NA",
    delete: "NA",
  },
  "Public Announcements": {
    edit: "NA",
    delete: "NA",
  },
  Roles: {
    edit: "YES",
    delete: "YES",
  },
  Users: {
    edit: "YES",
    delete: "YES",
  },
  "Region Management": {
    edit: "YES",
    delete: "NO",
  },
  "Contact Management": {
    edit: "YES",
    delete: "YES",
  },
  "Raise Grievance": {
    edit: "NO",
    delete: "NO",
  },
  "My Tickets": {
    edit: "NO",
    delete: "NO",
  },
  "Manage SLA": {
    edit: "YES",
    delete: "YES",
  },
  Resources: {
    edit: "YES",
    delete: "YES",
  },

  // ── Fleet modules ──
  // Route Planning
  "Vehicle Management": {
    edit: "YES",
    delete: "YES",
  },
  "Create/Assign Route": {
    edit: "YES",
    delete: "YES",
  },
  "Planned Route": {
    edit: "YES",
    delete: "NO",
  },
  "GPS Tracking": {
    edit: "NO",
    delete: "NO",
  },
  "Trip Tracker": {
    edit: "NO",
    delete: "NO",
  },
  "Accidents History": {
    edit: "NO",
    delete: "NO",
  },
  // Geofencing
  "Create/Assign Geofence": {
    edit: "NO",
    delete: "NO",
  },
  "Geofencing List": {
    edit: "NO",
    delete: "NO",
  },
  // OTA Management
  "OTA Management": {
    edit: "YES",
    delete: "YES",
  },
  // Face Management
  "Facial Registration": {
    edit: "YES",
    delete: "YES",
  },
  "Facial Detection": {
    edit: "NO",
    delete: "NO",
  },
  "Live Crowd Monitoring": {
    edit: "NO",
    delete: "NO",
  },
};

/**
 * Helper function to check if a permission is disabled
 * @param {string} moduleName - The name of the module
 * @param {string} permissionType - Either 'edit' or 'delete'
 * @returns {boolean} - True if the permission should be disabled
 */
export const isPermissionDisabled = (moduleName, permissionType) => {
  if (!moduleName || !permissionType) return false;

  const config = MODULE_PERMISSIONS_CONFIG[moduleName];
  if (!config) return false;

  const permissionValue = config[permissionType];

  // Disable if value is "NO", "NA", null, or undefined
  return (
    permissionValue === "NO" ||
    permissionValue === "NA" ||
    permissionValue === null ||
    permissionValue === undefined
  );
};

/**
 * Helper function to get all disabled modules for a specific permission type
 * @param {string} permissionType - Either 'edit' or 'delete'
 * @returns {string[]} - Array of module names that have the permission disabled
 */
export const getDisabledModulesForPermission = (permissionType) => {
  return Object.keys(MODULE_PERMISSIONS_CONFIG).filter((moduleName) =>
    isPermissionDisabled(moduleName, permissionType)
  );
};

/**
 * Helper function to check if BOTH edit and delete are disabled
 * @param {string} moduleName - The name of the module
 * @returns {boolean} - True if both permissions are disabled
 */
export const isBothPermissionsDisabled = (moduleName) => {
  return (
    isPermissionDisabled(moduleName, "edit") &&
    isPermissionDisabled(moduleName, "delete")
  );
};
